





























import { defineComponent, ref, watch } from '@vue/composition-api';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { useQuestion } from '@/bundles/Questions/composables/useQuestion';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { QueryParamRecord } from '@/bundles/App/type';
import { debounce } from '@/bundles/App/helpers';

import QuestionsListTable from '@/bundles/Questions/components/QuestionsListTable.vue';

export default defineComponent({
  name: 'Questions',

  components: {
    QuestionsListTable,
  },

  setup: function () {
    const { tableOptions, pageOffset } = usePagination();
    const { fetch, questions, total, pending } = useQuestion();

    async function fetchWrapper() {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      const params: QueryParamRecord[] = [
        {
          name: 'skip',
          value: pageOffset.value,
        },
        {
          name: 'take',
          value: tableOptions.value.itemsPerPage,
        },
      ];
      if (keyword.value) {
        params.push({ name: 'keyword', value: keyword.value });
      }
      try {
        await fetch(params);
      } catch (error) {
        console.error(error);
      }
    }

    function keywordSearch() {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
        return;
      }
      fetchWrapper();
    }
    const searchWrapper = debounce<typeof keywordSearch>(keywordSearch, 500);

    const keyword = ref('');
    watch(keyword, () => {
      searchWrapper();
    });

    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });
    function optionsChangeEventHandler(options: ITableOptions) {
      tableOptions.value = { ...options };
    }

    return {
      tableOptions,
      questions,
      total,
      pending,
      keyword,
      fetchWrapper,
      optionsChangeEventHandler,
    }
  }
});
